<template>
  <div :class="[$style.container]">
    <div :class="$style.avatarContainer">
      <div :class="$style.avatar">
        {{ avatarText }}
      </div>
    </div>
    <div :class="$style.contentContainer">
      <slot> </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Card extends Vue {
  @Prop({ default: '' })
  public avatarText!: string;
}
</script>

<style lang="scss" module>
.container {
  min-height: 150px;
  min-width: 150px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  box-shadow: 0 2px 2px $grey-border;
  border: 0.5px solid $grey-border;
  border-radius: 6px;
  background-color: #fbfbfb;

  .avatarContainer {
    .avatar {
      background: $primary;
      height: 40px;
      width: 40px;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .contentContainer {
    flex-grow: 1;
    line-break: auto;
    padding-left: 10px;
    color: $grey;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    overflow: visible;

    :first-child,
    :last-child {
      font-size: 14px;
      font-weight: bold;
      color: normal;
    }
  }
}
</style>
